import React, { Component } from 'react';
import PropTypes from "prop-types";



class AlertContainer extends Component {
    static propTypes = {
        type: PropTypes.string,
        className: PropTypes.string,
        text: PropTypes.string,
        onClose: PropTypes.func
    };
    static defaultProps = {
        type: "",
        className: "",
        text: "",
        onClose: null
    };


    _getAlertType = (type) => {
        switch (type) {
            case "primary":
                return "alert-primary";
            case "secondary":
                return "alert-secondary";
            case "success":
                return "alert-success";
            case "danger":
                return "alert-danger";
            case "warning":
                return "alert-warning";
            case "info":
                return "alert-info";
            case "light":
                return "alert-light";
            case "dark":
                return "alert-dark";
            default:
                return "";
        }
    }



    render = () => {
        return (
            <div className={`alert ${this._getAlertType(this.props.type)} ${this.props.className}`}
                role="alert"
            >
                {this.props.text}
                {(this.props.onClose!==null) && (
                    <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={this.props.onClose}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                )}

            </div>
        );
    }

}


/* Export Component ==================================================================== */
export default AlertContainer;